import React, { Fragment } from 'react';
import { useDispatch } from 'react-redux';
import { Divider, Grid, Typography } from '@material-ui/core';
import { marginBottom } from "../../../config/styles";
import DeleteCancel from "../../atoms/buttons/DeleteCancel";
import { invokePostService, handleSnackBar } from "../../../store/global/actions";
import Dialog from "../../atoms/dialog";


export default function DeleteUtilityFunction({ onClose, onCompletion, utilityFunction }) {
    const dispatch = useDispatch();
    const onDelete = () => {
        dispatch(invokePostService('deleteUtilityFunction', {}, [utilityFunction?._id]))
            .then((response) => {
                if (response.status) {
                    dispatch(handleSnackBar({
                        open: true,
                        message: "Utility function deleted",
                        severity: 'success'
                    }));
                    onCompletion();
                    onClose();
                } else {
                    dispatch(handleSnackBar({ open: true, message: 'Utility function delete failed', severity: 'error' }));
                }
            });
    }

    return (
        <Dialog
            open={true}
            handleClose={onClose}
            container_id="delete_utilityfunctcion_modal"
        > <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Typography variant="h6" >Delete</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Divider />
                </Grid>
                <Grid xs={12} style={marginBottom} className={"deleteDialogBox"}>
                    <Fragment>
                        <Typography> Are you sure you want to delete Utility Function {utilityFunction?.name} ? </Typography>
                    </Fragment>
                </Grid>

                <Grid item xs={12}>
                    <Divider />
                </Grid>

                <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }} >
                    <DeleteCancel onCancel={onClose} onDelete={onDelete} />
                </Grid>
            </Grid>
        </Dialog >

    )
}
